// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ReimbursementDetails from './reimbursement-details';
import t from 'tcomb';

const AuditRecordingClaim = t.struct({
    claimNumber: t.String,
    claimType: KeyValuePair,
    comments: t.String,
    creditMemoNumber: t.String,
    debitAmount: t.Number,
    debitType: KeyValuePair,
    pin: t.String,
    reimbursementDetails: ReimbursementDetails,
    responsibleAccount: t.String,
    subClaimType: KeyValuePair,
    workOrder: t.String
}, {
    name: 'AuditRecordingClaim',
    strict: true
});

export const getDefaultState = () => new AuditRecordingClaim({
    claimNumber: '',
    claimType: getKeyValuePairDefaultState(),
    comments: '',
    creditMemoNumber: '',
    debitAmount: 0,
    debitType: getKeyValuePairDefaultState(),
    pin: '',
    reimbursementDetails: new ReimbursementDetails({
        approvedAmount: 0,
        currency: getKeyValuePairDefaultState(),
        reimbursementPercentage: 0,
        requestedAmount: 0,
        withAdditives: 0
    }),
    responsibleAccount: '',
    subClaimType: getKeyValuePairDefaultState(),
    workOrder: ''
});

export default AuditRecordingClaim;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-recording-claim.js